<template>
  <div class="heightSkeleton">
    <v-skeleton-loader type="text" width="40px" />
    <div class="d-flex justify-space-between flex-column">
      <div v-for="item in 3" :key="item" class="d-flex flex-column align-center">
        <v-skeleton-loader type="text" width="100px" class="pa-1 ma-1" />
        <div class="d-flex ma-2">
          <v-skeleton-loader type="text" width="80px" /> <br />
          <v-skeleton-loader type="text" width="80px" />
        </div>
        <v-divider />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkeletonCarousel",
};
</script>

<style scoped>
.heightSkeleton {
  height: 100%;
}
@media (min-width: 960px) and (max-width: 1209px) {
  .v-skeleton-loader {
    max-width: 60px !important;
  }
}

 @media (min-width: 1260px) and (max-width: 1500px) {
  .v-skeleton-loader {
    max-width: 50px !important;
  }
}
</style>
